<div class="position-relative h-100">
  <div
    class="carousel-card d-flex flex-column justify-content-center position-relative shadow-sm h-100"
  >
    <div class="card-header p-2 px-3 text-left v-center d-flex flex-row align-items-center">
      <input type="checkbox" [(ngModel)]="data.selected" 
      (click)="triggerAction('select')"
      (keydown.enter)="triggerAction('select')"
      >
      <img src="assets/images/virtusa-icons/trend.png" alt="trend" class="mx-2">
      <span class="flex-grow-1 m-auto px-2">{{ data.name }}</span>
    </div>
    <div
      class="card-content py-2 d-flex flex-column justify-content-around flex-grow-1"
    >
      <div class="actions mt-1 px-3">
        <button
          (click)="triggerAction('code_repo')"
          class="btn-accello-secondary btn-accello d-flex p-1 px-2 mx-auto justify-content-center w-100"
        >
          Impact Analysis
        </button>
        <button
          (click)="triggerAction('mapping')"
          class="btn-accello-ternary btn-accello d-flex p-1 px-2 mx-auto my-2 justify-content-center w-100"
        >
          Existing Test Coverage
        </button>
      </div>
    </div>
  </div>
</div>
